export const CATEGORY_NAMES = {
    solar: "Solar Installers",
    aircon: "Heating & Cooling",
    plumbing: "Plumbing",
} as const;

export const BRAND_SERVICE_TYPES = ["solar", "aircon", "plumbing"] as const;

export type BrandServiceType = typeof BRAND_SERVICE_TYPES[number];

export const categoriesConfigs = [
    {
        name: CATEGORY_NAMES.solar,
        url_prefix: "/solar-installers/",
        id: 216,
    },
    {
        name: CATEGORY_NAMES.aircon,
        url_prefix: "/aircon-installers/",
        id: 7,
    },
    {
        name: CATEGORY_NAMES.plumbing,
        url_prefix: "/plumbers/",
        id: 14,
    },
];

export const getPrimaryCategoryName = (categories: any[] = []) =>
    categories?.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0))?.[0]?.category?.name || "";

export const hasCategoryName = (categories: any[] = [], categoryName: string) =>
    categories?.some((item) => item?.category?.name === categoryName);
